export const enum ETipoNaoPrevisto {
    CNP = 'cnp',
    ONP = 'onp'
}

export const enum EStatusAprovacaoSolicitacaoNaoPrevisto
{
    Pendente = "312fc736-0624-4bc3-a690-26da015a870d",
    Aprovado = "4075c4df-259e-4f73-bdc7-7391afe0b45d",
    Reprovado = "de84ed09-6e53-4976-8f17-c393f5b854f3",
    Validado = "ca1dcb46-f299-4a40-89d8-aa37365ddcdc",
    NaoValidado = "73f8118a-d284-4c0b-95c3-4783f236a632"
}

export const enum EStepsSolicitacaoNaoPrevisto {
    DefinicaoDoTipoDaSolicitacao = 'f24a5e12-f0dc-40d9-8ac2-c6d342667f1e',
    PreenchimentoDaSolicitacao = '5c4207cf-848f-4a29-8e44-c49c87b94b7a',
    ValidacaoGerenciaGFG = '05563b53-1880-46a9-b410-edfec8bd8888',
    ValidacaoAdministrador = 'd363e596-4054-4bbb-a26b-f72f07e63620',
    ValidacaoGDGPP = '29cf73df-7d30-42b5-bab6-1ad3ae97711e',
    GerenteGeralAreaSolicitante = 'd876a281-3795-472e-a6b6-56802a0057ce',
    DiretorAreaSolicitante = '3712b3ed-0d3b-4f48-ae45-32e32c5c9103',
    GerenteGeralGP = '338baa25-8c76-433f-8fb1-9e19c2973aea',
    DiretorImplantacao = '73729466-f9e8-4dd8-a099-5bab33bff068',
    DiretorSustentabilidade = 'ce6d884f-52b9-4062-9361-e276dcf7fc50',
    DiretorOperacoes = '1799b8f7-535b-4182-93fc-a9843ab85f74',
    DiretorFinanceiro = 'a04938af-226f-4152-b49d-164507a25e47',
    DiretorPresidente = '35aad1b9-6f2c-412f-8a64-051236e9269d',
    DiretorEstatutaria = '6c6a9693-aa1e-4420-8d74-ef30e2a4c32e',
    VincularNaoPrevistoAoProjeto = '1e06f0cf-8d71-496c-826a-0948f80a8bbd',
    Finalizado = '1b8a5e45-446f-4d17-984e-9bfe0aa5bb62'
}

export const enum EContratacaoNecessaria {
    Engenharia = 'engenharia',
    MateriaisEquipamentos = 'materiaisEquipamentos',
    Construcao = 'construcao',
    Outros = 'outros'
}

export const enum EMaturidadeEOuNivelDeDefinicao {
    EngConceitual = 'engConceitual',
    EngBasica = 'engBasica',
    EngDetalhada = 'engDetalhada',
    ConsultivaViaGa = 'consultivaViaGa',
    DepDeclaracaodoEscopoDoProjeto = 'depDeclaracaodoEscopoDoProjeto',
    Outros = 'outros'
}

export const enum ETipoAprovacaoSolicitacaoNaoPrevisto {
    ValidacaoAdministrador = '3f975df4-ea38-45af-9665-6447abdacf3e',
    ValidacaoGerenciaGFG = '7880f1bf-e571-4281-b4ad-a610ed4927d1',
    ValidacaoGDGPP = '0118c53b-386a-4d8a-a567-fd1ab7975906',
    GerenteGeralAreaSolicitante = '616dc8b0-85cd-4cff-9d1f-eaafedd5699a',
    DiretorAreaSolicitante = '8826b0bc-989f-4626-83f7-348f79556fc9',
    GerenteGeralGP = 'ded6778b-d066-4739-b1a7-490b31a7537a',
    DiretorImplantacao = '9ac4d245-221b-43ba-ba99-5aeaf4472e49',
    DiretorSustentabilidade = '58924391-3269-4589-8294-82bb2b870ddc',
    DiretorOperacoes = 'ee67c190-4a52-4423-a181-c886c2f2ecce',
    DiretorFinanceiro = '4d37bac2-ec4a-438a-96e7-7661d6df3d97',
    DiretorPresidente = '8e13e1e7-49df-4008-953a-25fb589c7a2e',
    DiretorEstatutaria = 'a41f1a05-9fdf-4748-9452-841af9d274fc'
}

export const enum EStatusSolicitacaoNaoPrevisto {
    Criada = '10d0ea1f-4e67-4e92-b75c-a03787e6d9eb',
    PreenchimentoDaSolicitacao = 'd64cd2e2-506e-4e9e-974f-8684c7315e3f',
    ValidacaoGerenciaGFG = '0971bede-56cc-4767-9425-2ad13a935a23',
    ValidacaoAdministrador = '6a48668f-29b1-4f7f-8877-e36a597d3b26',
    ValidacaoGDGPP = '00d4d3b1-e912-4688-a8e0-d2e8813fdc9b',
    GerenteGeralAreaSolicitante = '00c8a26d-1ff8-4575-a57f-4dc4f04f3231',
    DiretorAreaSolicitante = '49fbf007-9b5f-42e2-833f-d80a47ee1ea0',
    GerenteGeralGP = 'e3bb21c2-95c1-4dfd-931f-02405a66e1eb',
    DiretorImplantacao = '2f3d6477-ff11-4b49-b440-60710ee165bd',
    DiretorSustentabilidade = '21ce0ecb-db68-44c4-93a8-d22680eab710',
    DiretorOperacoes = 'a1e80ac9-db60-43c3-aae1-5dc101b71e19',
    DiretorFinanceiro = '23bff653-f540-4029-8f93-06f43f488987',
    DiretorPresidente = '884e51fe-701a-4e59-8f50-0f3ea2099b1b',
    DiretorEstatutaria = 'c47b6c7f-ad33-47e2-a7a6-77830ccf061b',
    VincularNaoPrevistoAoProjeto = 'e49693a2-12d7-4d29-ab8e-1f350f3a05e4',
    Aprovada = '442d58c3-c851-4ac0-8a9c-16824a4c4842',
    Reprovado = 'e2740fe1-9cb3-41d6-950d-d184bf647076',
    NaoValidado = '2db7b493-21cd-4e35-b08e-baedc3708d55',
    Encerrada = '1a50201b-73f8-482a-960c-76061ed4c615',
    DefinicaoDoTipoDaSolicitacao = '2eade388-8db4-4e30-80a6-f042bb124acb'
}